import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useStableAuth } from './useStableAuth';

export interface CompanyUser {
  id: string;
  full_name: string;
  avatar_url?: string;
  user_position?: string;
  email?: string;
}

export const useCompanyUsers = (excludeUserIds: string[] = []) => {
  const { companyId } = useStableAuth();

  const { data: users = [], isLoading: loading } = useQuery({
    queryKey: ['company-users', companyId, excludeUserIds.join(',')],
    queryFn: async () => {
      if (!companyId) return [];

      const { data, error } = await supabase
        .rpc('get_profiles_secure');

      if (error) {
        console.error('Erro ao carregar usuários:', error);
        throw error;
      }
      
      // Filtrar usuários excluídos, inativos e mapear para o formato esperado
      const filteredUsers = (data || [])
        .filter((u: any) => !excludeUserIds.includes(u.user_id) && u.active !== false)
        .map((u: any) => ({
          id: u.user_id,
          full_name: u.full_name,
          avatar_url: u.avatar_url || undefined,
          user_position: u.user_position || undefined,
          // Email pode estar mascarado dependendo das permissões
          email: u.is_masked ? undefined : (u.email || undefined)
        }));
      
      return filteredUsers as CompanyUser[];
    },
    enabled: !!companyId,
  });

  return { users, loading };
};
